export class SettingsParkingRule {
    static fromExistingData(rule: any): SettingsParkingRule {
        const settingsParkingRule = new SettingsParkingRule();

        if (rule.id) settingsParkingRule.id = rule.id;
        if (rule.name) settingsParkingRule.name = rule.name;
        if (rule.internalId) settingsParkingRule.internalId = rule.internalId;
        if (rule.type) settingsParkingRule.type = rule.type;
        if (rule.lotRule) settingsParkingRule.parkingLots = rule.lotRule.map(l => (l.parkingLot));
        if (rule.enableStatus) settingsParkingRule.enableStatus = rule.enableStatus;
        if (rule.createdAt) settingsParkingRule.createdAt = rule.createdAt;
        if (rule.createdBy) settingsParkingRule.createdBy = rule.createdBy.fullName;
        if (rule.legalAgreement) settingsParkingRule.legalAgreement = rule.legalAgreement;
        if (rule.legalAgreementStatus) settingsParkingRule.legalAgreementStatus = rule.legalAgreementStatus;
        if (rule.disclaimer) settingsParkingRule.disclaimer = rule.disclaimer;
        if (rule.passTypes) settingsParkingRule.passTypes = rule.passTypes;
        if (rule.limitGroups) settingsParkingRule.limitGroups = this.parseLimitGroups(rule.limitGroups);
        if (rule.disclaimerStatus) settingsParkingRule.disclaimerStatus = rule.disclaimerStatus;
        if (rule.minIntervalBetweenBooking) settingsParkingRule.minIntervalBetweenBooking = rule.minIntervalBetweenBooking;
        if (rule.maxPassCountPerBooking) settingsParkingRule.maxPassCountPerBooking = rule.maxPassCountPerBooking;
        if (rule.maxBookingsPerSuiteCount) settingsParkingRule.maxBookingsPerSuiteCount = rule.maxBookingsPerSuiteCount;
        if (rule.maxBookingsPerSuiteSequenceType) settingsParkingRule.maxBookingsPerSuiteSequenceType = rule.maxBookingsPerSuiteSequenceType;
        if (rule.maxBookingsPerLicensePlateCount) settingsParkingRule.maxBookingsPerLicensePlateCount = rule.maxBookingsPerLicensePlateCount;
        if (rule.maxBookingsPerLicensePlateSequenceType) settingsParkingRule.maxBookingsPerLicensePlateSequenceType = rule.maxBookingsPerLicensePlateSequenceType;
        if (rule.acceptCash) settingsParkingRule.acceptCash = rule.acceptCash;
        if (rule.acceptCheques) settingsParkingRule.acceptCheques = rule.acceptCheques;
        if (rule.acceptCreditCards) settingsParkingRule.acceptCreditCards = rule.acceptCreditCards;
        if (rule.defaultPaymentMethod) settingsParkingRule.defaultPaymentMethod = rule.defaultPaymentMethod;
        if (rule.legalAgreementStatus) settingsParkingRule.legalAgreementStatus = rule.legalAgreementStatus;
        if (rule.legalAgreementHideFromStaffInterface) settingsParkingRule.legalAgreementHideFromStaffInterface = rule.legalAgreementHideFromStaffInterface;
        if (rule.disclaimerHideFromStaffInterface) settingsParkingRule.disclaimerHideFromStaffInterface = rule.disclaimerHideFromStaffInterface;
        if (rule.confirmationMessage) settingsParkingRule.confirmationMessage = rule.confirmationMessage;
        if (rule.allowResidentsToBook) settingsParkingRule.allowResidentsToBook = rule.allowResidentsToBook;
        if (rule.staffNotificationSettings) settingsParkingRule.staffNotificationSettings = rule.staffNotificationSettings;
        if (rule.residentsNotificationSettings) settingsParkingRule.residentsNotificationSettings = rule.residentsNotificationSettings;
        settingsParkingRule.isCanEdit = rule.isCanEdit;
        settingsParkingRule.isCanDelete = rule.isCanDelete;
        return settingsParkingRule;
    }

    private static parseLimitGroups(limitGroups): any {
        return limitGroups.map(group => {
            const formattedLimitedPassTypes = group.limitedPassTypes.map(l => ({
                id: l.id,
                itemName: l.name
            }));
            return {
                limitCount: group.limitCount,
                limitSequenceType: group.limitSequenceType,
                limitedPassTypes: formattedLimitedPassTypes
            };
        });
    }

    constructor(
        public id: number = null,
        public name: string = '',
        public timeSequenceType: string = '',
        public uses: Array<any> = [],
        public enableStatus = false,
        public allowResidentsToBook = false,
        public requiresManagerApproval = false,
        public allowEventTypeBooking = false,
        public legalAgreement: string = '',
        public legalAgreementStatus = false,
        public disclaimer: string = '',
        public disclaimerStatus = false,
        public multipleBooking = false,
        public multipleBookingMaxCount: number = null,
        public amenityImage: string = '',
        public rule: any = null,
        public bookings: Array<any> = null,
        public fees: Array<any> = null,
        public disabledDates: Array<any> = null,
        public parkingLots: any = [],
        public type: string = '',
        public passTypes: any = [],
        public limitGroups: any = [],
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public internalId: string = '',
        public template: string = '',
        public saveAsTemplate = false,
        public templateName: string = '',
        public bookingMinDay: number = null,
        public bookingMaxDay: number = null,
        public bookingMinHour: number = null,
        public bookingMaxHour: number = null,
        public limitActivityRangeValue: string = '',
        public minIntervalBetweenBooking: string = '',
        public maxPassCountPerBooking: string = '',
        public limitActivityCountBookingOrDays: string = '',
        public limitActivityCountBookingOrHours: string = '',
        public limitActivityCountBooking: string = '',
        public maxTimeForAdvancedBooking: string = '',
        public maxBookingsPerSuiteCount: string = '',
        public maxBookingsPerSuiteSequenceType: string = '',
        public maxBookingsPerLicensePlateCount: string = '',
        public maxBookingsPerLicensePlateSequenceType: string = '',
        public confirmationMessage: string = '',
        public staffNotificationSettings: any = null,
        public residentsNotificationSettings: any = null,
        public legalAgreementHideFromStaffInterface: boolean = false,
        public disclaimerHideFromStaffInterface: boolean = false,
        public acceptCreditCards: boolean = false,
        public acceptCash: boolean = false,
        public acceptCheques: boolean = false,
        public defaultPaymentMethod: string = '',
        public amenityColor: string = '',
        public managementOverride: boolean = false,
        public formFields = {
            defaultPaymentMethod: {editMode: false}
        },
        public createdBy: string = '',
        public createdAt: string = ''
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsParkingRule.ts